module.exports = __webpack_public_path__ + "static/media/star-exercise-dashboard.65c7fd5e.png";